import { EmpathizeLayout, EmpathizeLayoutItem, EmpathizeState } from '../../../models';
import { RootStoreState } from '../../store.interfaces';
import { EMPATHIZE_GETTERS_KEYS } from '../empathize.const';
import { EmpathizeGetter } from '../empathize.interfaces';

export class HighlightedEmpathizeItemGetter implements EmpathizeGetter {
  getters = {
    [EMPATHIZE_GETTERS_KEYS.highlightedEmpathizeItem]: (state: EmpathizeState, getters: any, rootState: RootStoreState,
      rootGetters: any): any => {
      const elements: any[] = rootGetters[this.getLayoutItem(state, getters).getter];
      return elements[state.selectedIndex];
    },
    [EMPATHIZE_GETTERS_KEYS.highlightedEmpathizeLayoutItem]: (state: EmpathizeState, getters: any) => this.getLayoutItem(state, getters)
  };

  private getLayoutItem(state: EmpathizeState, getters: any): EmpathizeLayoutItem {
    const layout: EmpathizeLayout = getters[EMPATHIZE_GETTERS_KEYS.layout];
    return layout[state.selectedEmpathizeBlock.y][state.selectedEmpathizeBlock.x];
  }
}
